interface ManualSaveButtonProps {
  isSaving: boolean;
  onSave: () => void;
}

export function ManualSaveButton({ isSaving, onSave }: ManualSaveButtonProps) {
  return (
    <button
      className="studio-action-button studio-action-button--save"
      disabled={isSaving}
      onClick={onSave}
      type="button"
      aria-label={isSaving ? "Saving drawing" : "Save drawing now"}
    >
      <span aria-hidden="true">{isSaving ? "…" : "✓"}</span>
      {isSaving ? "Saving" : "Save"}
    </button>
  );
}
